// Board: GameEndedHostGone.
import React from 'react';
import { t } from '../../i18n';
import { Logo, onTap } from '../Home/parts';

export default function GameEndedHostGone({ onHome }) {
  return (
    <main className="screen" style={{ background: '#24102a', color: '#fff6e0', alignItems: 'center', justifyContent: 'center', gap: 36, padding: '40px 24px 48px' }}>
      <Logo width="150" height="120" line="#fff6e0" style={{ opacity: 0.55 }} />

      <div role="status" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, textAlign: 'center' }}>
        <h1 style={{ margin: 0, font: '400 52px/1.05 var(--display)', color: '#ee5a4a' }}>{t('end.over')}</h1>
        <p style={{ margin: 0, font: '500 18px/1.45 var(--sans)', color: '#fff6e0', maxWidth: 300 }}>{t('end.hostGone')}</p>
      </div>

      <div style={{ flex: '0 0 24px' }}></div>
      <a className="btn btn-primary btn-block" href="#home" onClick={onTap(onHome)} style={{ borderColor: '#fff6e0', boxShadow: '0 4px 0 #fff6e0' }}>{t('end.home')}</a>
    </main>
  );
}
